import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

export const unassignMetaListGet = createAsyncThunk('help-desk-meta/unassign', async (params) => {
  return await apiInstance.get('/help-desk/meta/unassign/whatsapp', { params });
});

export const assignMetaListGet = createAsyncThunk('help-desk-meta/assign', async (params) => {
  return await apiInstance.get('/help-desk/meta/assign/whatsapp', { params });
});

export const metaHelpHistoryGet = createAsyncThunk(
  'help-desk-meta/chat-history',
  async (params) => {
    return await apiInstance.get('/help-desk/meta/whatsapp/chat-history', { params });
  }
);

export const unreadMetaCountGet = createAsyncThunk('help-desk-meta/unread', async (params) => {
  return await apiInstance.get('/help-desk/meta/whatsapp/unread', { params });
});

export const metaHelpMarkAsRead = createAsyncThunk('help-desk-meta/mark-read', async (payload) => {
  return await apiInstance.put('/help-desk/meta/whatsapp/mark-read', payload);
});

export const sendMetaHelpMsg = createAsyncThunk('help-desk-meta/send-message', async (formData) => {
  return await apiInstance.post('/help-desk/meta/whatsapp/send-message', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
});

export const assignToAgentMeta = createAsyncThunk(
  'help-desk-meta/assign-to-agent',
  async (payload) => {
    return await apiInstance.post('/help-desk/meta/whatsapp/assign-to-agent', payload);
  }
);

export const addMetaHelpNote = createAsyncThunk('help-desk-meta/note', async (payload) => {
  return await apiInstance.post('/help-desk/meta/whatsapp/note', payload);
});

export const getMetaHelpNote = createAsyncThunk('help-desk-meta/get-note', async (params) => {
  return await apiInstance.get('/help-desk/meta/whatsapp/get-note', { params });
});

export const whatsappMetaEditDetails = createAsyncThunk(
  'help-desk-meta/whatsapp/edit-details',
  async (payload) => {
    return await apiInstance.put('/help-desk/meta/whatsapp/edit-details', payload);
  }
);

export const whatsappMetaAddDetails = createAsyncThunk(
  'help-desk-meta/whatsapp/optional-send-message',
  async (payload) => {
    return await apiInstance.post('/help-desk/meta/whatsapp/optional-send-message', payload);
  }
);

const initialState = {
  unassignMetaList: [],
  assignMetaList: [],
  activeMetaHelpDetails: null,
  helpMetaCountList: []
};

const metaHelpDeskSlice = createSlice({
  name: 'metaHelpDesk',
  initialState,
  reducers: {
    setActiveMetaHelpDetails(state, action) {
      state.activeMetaHelpDetails = action.payload;
    },
    clearMetaHelpDeskSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(unassignMetaListGet.fulfilled, (state, action) => {
      const data = [...(action?.payload?.data || [])];
      state.unassignMetaList = data?.map((val) => {
        return {
          ...val,
          name: val?.from_name,
          id: val?._id
        };
      });
    });
    builder.addCase(assignMetaListGet.fulfilled, (state, action) => {
      const data = [...(action?.payload?.data || [])];
      state.assignMetaList = data?.map((val) => {
        return {
          ...val,
          name: val?.from_name,
          id: val?._id
        };
      });
    });
    builder.addCase(unreadMetaCountGet.fulfilled, (state, action) => {
      state.helpMetaCountList = [...(action?.payload?.data || [])];
    });
  }
});

export default metaHelpDeskSlice.reducer;
export const { clearMetaHelpDeskSlice, setActiveMetaHelpDetails } = metaHelpDeskSlice.actions;

export const selectUnassignMetaList = (state) => state.metaHelpDesk.unassignMetaList;
export const useUnassignMetaList = () => {
  const unassignMetaList = useSelector(selectUnassignMetaList);
  return useMemo(() => unassignMetaList, [unassignMetaList]);
};

export const selectAssignMetaList = (state) => state.metaHelpDesk.assignMetaList;
export const useAssignMetaList = () => {
  const assignMetaList = useSelector(selectAssignMetaList);
  return useMemo(() => assignMetaList, [assignMetaList]);
};

export const selectActiveMetaHelpDetails = (state) => state.metaHelpDesk.activeMetaHelpDetails;
export const useActiveMetaHelpDetails = () => {
  const activeMetaHelpDetails = useSelector(selectActiveMetaHelpDetails);
  return useMemo(() => activeMetaHelpDetails, [activeMetaHelpDetails]);
};

export const selectHelpMetaCountList = (state) => state.metaHelpDesk.helpMetaCountList;
export const useHelpMetaCountList = () => {
  const helpMetaCountList = useSelector(selectHelpMetaCountList);
  return useMemo(() => helpMetaCountList, [helpMetaCountList]);
};
